import React from 'react';
import LocationTemplate from './LocationTemplate';

const ManteoPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Manteo"
      stateName="North Carolina"
      countyName="Dare"
      zipCodes={["27954"]}
      latitude={35.9088}
      longitude={-75.6696}
      population={1434}
      historicalFact="Named after Manteo, a Native American chief who helped the English colonists at Roanoke Island."
      nearbyTowns={[
        "Nags Head, NC",
        "Kill Devil Hills, NC",
        "Kitty Hawk, NC",
        "Duck, NC",
        "Elizabeth City, NC",
        "Hatteras, NC",
        "Outer Banks, NC",
        "Hertford, NC"
      ]}
    />
  );
};

export default ManteoPage;